
import React from 'react';
import cx from 'clsx';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  type?: 'autoHeight';
}

const NoData: React.FC<IProps> = ({ type }) => {
  const { t } = useTranslation();
  return (
    <div className={cx(style.noData, { [style.autoHeight]: type === 'autoHeight' })}>
      {t('No Data')}
    </div>
  )
}

export default NoData;